import { ExcelTemplateTypes, PromotionEntryTemplateSearchTypes } from "enums";
import { useInOutTransition } from "hooks";
import SearchRadioInput from "./SearchRadioInput";

interface Props {
    searchType: string,
    updateHandler: (x: PromotionEntryTemplateSearchTypes) => void,
    selectedTemplateType: ExcelTemplateTypes
}

export default function PromotionEntryTemplateSearchOptions(props: Props) {
    const { searchType, updateHandler, selectedTemplateType } = props,
          shouldRender = selectedTemplateType === ExcelTemplateTypes.PromotionEntry,
          { isActive, isNotTransitionedOut } = useInOutTransition(shouldRender, 0, 275);
    return (isNotTransitionedOut && 
        <>

            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="promotionId" 
                              labelText="Promotion ID" 
                              checkedCondition={searchType === PromotionEntryTemplateSearchTypes.PromotionId}
                              onClick={() => updateHandler(PromotionEntryTemplateSearchTypes.PromotionId)} />

            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="promotionDescription" 
                              labelText="Promotion Name" 
                              checkedCondition={searchType === PromotionEntryTemplateSearchTypes.PromotionDescription}
                              onClick={() => updateHandler(PromotionEntryTemplateSearchTypes.PromotionDescription)} />
                              
            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="customerId" 
                              labelText="Customer ID"
                              checkedCondition={searchType === PromotionEntryTemplateSearchTypes.CustomerId}
                              onClick={() => updateHandler(PromotionEntryTemplateSearchTypes.CustomerId)} />
            
            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="customerName" 
                              labelText="Customer Name" 
                              checkedCondition={searchType === PromotionEntryTemplateSearchTypes.CustomerName}
                              onClick={() => updateHandler(PromotionEntryTemplateSearchTypes.CustomerName)} />

            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="productLineNumber" 
                              labelText="Product Line Number" 
                              checkedCondition={searchType === PromotionEntryTemplateSearchTypes.ProductLineNumber}
                              onClick={() => updateHandler(PromotionEntryTemplateSearchTypes.ProductLineNumber)} />

            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="productLineCategoryNumber" 
                              labelText="Product Category Number" 
                              checkedCondition={searchType === PromotionEntryTemplateSearchTypes.ProductLineCategoryNumber}
                              onClick={() => updateHandler(PromotionEntryTemplateSearchTypes.ProductLineCategoryNumber)} />

            <SearchRadioInput className={shouldRender && isActive ? "" : "hidden"}
                              id="itemNumber" 
                              labelText="Item Number" 
                              checkedCondition={searchType === PromotionEntryTemplateSearchTypes.ItemNumber}
                              onClick={() => updateHandler(PromotionEntryTemplateSearchTypes.ItemNumber)} />
            
        </>
    );
}
